<div class="d-none d-lg-block">
  <div class="banner" role="banner">
    <h1>{{ 'wallet.page.title' | translate }}</h1>
  </div>
  <ng-container *notInPopulation="[populations.U18]">
    <fgb-mixed-loyalty-nav></fgb-mixed-loyalty-nav>
  </ng-container>
</div>

<div class="d-lg-none d-block">
  <fgb-barcode [isWalletPage]="true"></fgb-barcode>
</div>

<!-- Wallet -->
<ng-container *ngIf="walletItems$ | async as walletItems">
  <div class="wallet-redeem-carousel pt-3">
    <div class="container">
      <fgbcl-rewards-wallet-redeem-list [unRedeemedItems]="walletItems"></fgbcl-rewards-wallet-redeem-list>
    </div>
  </div>
</ng-container>

<div class="container mt-3 text-center mb-5">
  <div class="claimed-button">
    <div class="claimed-button-text">
      <h5 class="mb-1">REDEMPTION HISTORY</h5>
      <div class="font-size-14">View history of your redemptions</div>
    </div>
    <a
      class="font-size-14 claimed-text fw-bold btn btn-primary border-secondary rounded text-secondary"
      [routerLink]="['/rewards/claimed']"
    >
      {{ 'rewards.wallet.view.claimed' | translate }}
    </a>
  </div>
</div>
